<div class="fcp-widget">
  <!-- Loading -->
  <div *ngIf="loading" class="fcp-state">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ 'FLEXI_COMPLIANCE.LOADING' | translate }}</span>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && summary && summary.totalCount === 0" class="fcp-state">
    <i class="pi pi-chart-pie"></i>
    <p>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.EMPTY' | translate }}</p>
  </div>

  <!-- Populated -->
  <div *ngIf="!loading && summary && summary.totalCount > 0" class="fcp-grid">
    <!-- Chart + summary chips -->
    <div class="fcp-chart" #chartHost>
      <div class="fcp-chart__totals">
        <span class="fcp-chip is-green"
              [class.is-active]="activeFilter === 'green'"
              (click)="setFilter('green')">
          <strong>{{ summary.greenCount }}</strong>
          {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.GREEN_LABEL' | translate }}
        </span>
        <span class="fcp-chip is-yellow"
              [class.is-active]="activeFilter === 'yellow'"
              (click)="setFilter('yellow')">
          <strong>{{ summary.yellowCount }}</strong>
          {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.YELLOW_LABEL' | translate }}
        </span>
        <span class="fcp-chip is-red"
              [class.is-active]="activeFilter === 'red'"
              (click)="setFilter('red')">
          <strong>{{ summary.redCount }}</strong>
          {{ 'FLEXI_COMPLIANCE.SCORE_CHIP.RED_LABEL' | translate }}
        </span>
        <span class="fcp-total">
          {{ summary.totalCount }}
          {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.BUSINESSES' | translate }}
        </span>
      </div>

      <ngx-charts-pie-chart
        [view]="view"
        [scheme]="colorScheme"
        [customColors]="customColors"
        [results]="chartData"
        [gradient]="gradient"
        [legend]="showLegend"
        [legendPosition]="legendPosition"
        [legendTitle]="legendTitle"
        [labels]="showLabels"
        [doughnut]="isDoughnut"
        (select)="onSliceSelect($event)">
      </ngx-charts-pie-chart>
    </div>

    <!-- Supporting business list -->
    <div class="fcp-list">
      <div class="fcp-list__head">
        <h5>
          {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.BUSINESSES' | translate }}
          <span class="fcp-list__count" *ngIf="activeFilter !== null">
            · {{ smileyLabelKey(activeFilter) | translate }}
          </span>
        </h5>
        <button type="button"
                class="fcp-list__clear"
                *ngIf="activeFilter !== null"
                (click)="setFilter(null)">
          <i class="pi pi-times"></i>
          {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.CLEAR_FILTER' | translate }}
        </button>
        <button type="button"
                class="fcp-list__clear"
                (click)="goToList(activeFilter)">
          <i class="pi pi-list"></i>
          {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.VIEW_ALL' | translate }}
        </button>
      </div>

      <ul class="fcp-list__rows">
        <li *ngFor="let row of paginatedRows"
            class="fcp-row"
            [ngClass]="smileyClass(row.smiley)"
            (click)="openBusiness(row)"
            [title]="'FLEXI_COMPLIANCE.PORTAL_WIDGET.OPEN_BUSINESS' | translate">
          <span class="fcp-row__dot" [ngClass]="smileyClass(row.smiley)"></span>
          <span class="fcp-row__name">{{ row.businessName }}</span>
          <span class="fcp-row__pct">{{ row.percentage }}%</span>
        </li>
        <li *ngIf="paginatedRows.length === 0" class="fcp-row fcp-row--empty">
          {{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.EMPTY_FILTER' | translate }}
        </li>
      </ul>

      <div class="fcp-list__pager" *ngIf="totalPages > 1">
        <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
          <i class="pi pi-chevron-left"></i>
        </button>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
